<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-layout xs4 mb-2>
          <v-flex mt-4>
            <h1>Listagem de Cotas da Notificação</h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <hr class="solid" />
    <v-layout>
      <v-layout column mt-3 class="card">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col cols="2"
              >
                <v-btn color="error" @click="acessar(menuRoute('notificacoes'));"> Voltar </v-btn>
              </v-col
              >
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table :headers="headers" :items="cotasNotificacao"
                              :footer-props="{
                                'items-per-page-options': [10, 25, 50, -1]
                              }"
                              :items-per-page="10"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.Cota.nomeCliente }}</td>
                      <td>{{ item.Cota.grupo }}</td>
                      <td>{{ item.Cota.numeroCota }}</td>
                      <td>{{ item.Cota.cpfcnpj }}</td>
                      <td align="center">
                        <v-chip
                            class="ma-2"
                            color="orange"
                            text-color="white"
                            v-if="item.statusEnvio === 'AGENDADO'"
                        >
                          {{ item.statusEnvio }}
                        </v-chip>
                        <v-chip
                            class="ma-2"
                            color="green"
                            text-color="white"
                            v-if="item.statusEnvio === 'ENVIADO'"
                        >
                          {{ item.statusEnvio }}
                        </v-chip>
                        <v-chip
                            class="ma-2"
                            color="red"
                            text-color="white"
                            v-if="item.statusEnvio === 'FALHA'"
                        >
                          {{ item.statusEnvio }}
                        </v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
  import DataTable from '../components/DataTable'

  export default {
    name: 'NotificacaoCotas',
    components: { DataTable },
    data: () => ({
      cotas: [],
      cotasNotificacao: [],
      headers: [
        { text: 'Nome do Cliente', value: 'Cota.nomeCliente' },
        { text: 'Grupo', value: 'Cota.grupo' },
        { text: 'Cota', value: 'Cota.numeroCota' },
        { text: 'CPF/CNPJ', value: 'Cota.cpfcnpj' },
        { text: 'Status', value: 'statusEnvio' }
      ]
    }),
    mounted () {
      this.listarCotas()
    },
    methods: {
      listarCotas () {
        this.loading = true

        return this.$http
          .post('/Cota?offSet=0&limit=0', {})
          .then((res) => {
            this.cotas = []
            this.$nextTick(() => {
              this.cotas = res.data
              this.carregarCotasNotificacao()
            })
          })
          .catch(() => {
          // cancel
          })
          .finally(() => {
            this.loading = false
          })
      },
      carregarCotasNotificacao () {
        this.loading = true

        let notificaoID = parseInt(
          window.localStorage.getItem('notificacaoListarCotas')
        )

        return this.$http
          .get('/NotificacaoDestinatario/GetByNotificacaoID/' + notificaoID)
          .then((res) => {
            this.cotasNotificacao = []
            this.$nextTick(() => {
              this.cotasNotificacao = res.data

              this.cotasNotificacao.forEach((x) => {
                x.Cota = this.cotas.find((c) => c.id === x.cotaID)
              })
            })
          })
          .catch(() => {
          // cancel
          })
          .finally(() => {
            this.loading = false
            window.localStorage.removeItem('notificacaoListarCotas')
          })
      },
      menuRoute (name) {
        try {
          const route = this.$router.resolve({ name }).route
          const selected = this.$route.path.startsWith(route.path)
          return route.matched.length
            ? { text: route.meta.title, to: route.path, selected }
            : { text: '// fixme' }
        } catch (e) {
          return false
        }
      },
      acessar (item) {
        if (item.click) {
          item.click()
        } else {
          try {
            if (this.$route.path !== item.to) {
              this.$router.push(item.to)
            }
          } catch (e) {
            return false
          }
        }
      }
    }
  }
</script>
